import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { SearchResultSkeleton } from '../../../../common/ui/search-result-skeleton';

const resultsListGridAreaStyles = xcss({
	gridArea: 'results-list',
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
});

export const Loading = (): React.JSX.Element => {
	return (
		<Box xcss={resultsListGridAreaStyles} testId="search-page-results-list">
			<SearchResultSkeleton />
			<SearchResultSkeleton />
			<SearchResultSkeleton />
			<SearchResultSkeleton />
		</Box>
	);
};
